import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as promotionworldGroupedActions from './promotionworldGridGroupedActions';
import { IPromotionworldGridGroupType } from '../../types/IPromotionworldGridGroupType';

export type PromotionworldGroupedAction = ActionType<typeof promotionworldGroupedActions>;

export interface IPromotionworldGroupedStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IPromotionworldGridGroupType };
	readonly queries: { [queryKey: string]: IPromotionworldGridGroupType[] };
}

export function promotionworldGroupedReducer(
	state = baseInitialState as IPromotionworldGroupedStateType,
	action: PromotionworldGroupedAction,
) {
	const Reducer = new BaseReducer('promotionworldGroupedReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
